function waitForElement(selector, callback, interval = 300, timeout = 5000) {
  const startTime = Date.now();

  const waitingInterval = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      clearInterval(waitingInterval);
      callback(element);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(waitingInterval);
    }
  }, interval);
}

function replaceSearchIcon() {
  waitForElement(".pf-search-icons", (oldSearchDiv) => {
    const newSearchDiv = document.createElement("div");
    newSearchDiv.className = "pf-searchIcons";
    newSearchDiv.innerHTML = `
      <a href="/search" class="tap-area searchIcon sm:block" aria-controls="search-drawer">
        <span class="sr-only">Ouvrir la recherche</span>
        <svg role="presentation" stroke-width="2" focusable="false" width="22" height="22" class="icon icon-search" viewBox="0 0 22 22">
          <circle cx="11" cy="10" r="7" fill="none" stroke="currentColor"></circle>
          <path d="m16 15 3 3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      </a>
    `;

    oldSearchDiv.replaceWith(newSearchDiv);

  });
}

replaceSearchIcon();


function typeEffect(element, categories, typingSpeed = 100, pauseTime = 1500) {
  let index = 0;
  let charIndex = 0;
  let isDeleting = false;
  let timeoutId = null;

  function clearTimeouts() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  function type() {
    clearTimeouts();
    const currentCategory = categories[index];

    if (!currentCategory) {
      return;
    }

    if (isDeleting) {
      if (charIndex > 0) {
        charIndex--;
        element.textContent = currentCategory.substring(0, charIndex);
        timeoutId = setTimeout(type, typingSpeed / 2);
      } else {
        isDeleting = false;
        index = (index + 1) % categories.length;
        timeoutId = setTimeout(type, 500);
      }
    } else {
      if (charIndex < currentCategory.length) {
        charIndex++;
        element.textContent = currentCategory.substring(0, charIndex);
        timeoutId = setTimeout(type, typingSpeed);
      } else {
        timeoutId = setTimeout(() => {
          isDeleting = true;
          type();
        }, pauseTime);
      }
    }
  }

  type();
  return clearTimeouts;
}

function getActiveLanguage() {
  const wglang = localStorage.getItem('wglang');
  
  if (wglang) {
    return wglang;
  }

  console.warn("No language found in localStorage. Defaulting to German (de).");
  return "de";
}

function getCategoriesByLanguage(languageCode) {
  const headerSection = document.querySelector('#shopify-section-header');
  if (!headerSection) {
    console.warn("Header section not found. Using default categories.");
    return getDefaultCategories(languageCode);
  }

  const categoriesString = headerSection.dataset[`categories${languageCode.toUpperCase()}`];
  
  if (categoriesString) {
    return categoriesString.split(',').map(category => category.trim());
  }

  console.warn(`No categories found for language ${languageCode}. Using defaults.`);
  return getDefaultCategories(languageCode);
}

function getDefaultCategories(languageCode) {
  const defaultCategories = {
    en: "Bundles,Leg Wraps,Foot mat,Yoga Mat,Pillow,Sets,Accessories,Spiky Ball,Headband,Ring,Eyepillow,Mats",
    de: "Bundles,Leg Wraps,Fußmatte,Yogamatte,Kissen,Sets,Zubehör,Spiky Ball,Stirnband,Ring,Augenkissen,Matten",
    fr: "Packs,Jambières,Tapis pour les pieds,Tapis de yoga,Coussin,Sets,Accessoires,Balle à pointes,Bandeau,Anneau,Oreiller pour les yeux,Tapis",
    es: "Packs,Mangas de acupresión para piernas,Tapete para pies,Tapete de yoga,Cojín,Sets,Accesorios,Bola de picos,Banda para la Cabeza,Anillo,Almohadilla para ojos,Esterillas",
    pt: "Packs,Perneiras,Tapete para pés,Tapete de ioga,Almofada,Conjuntos,Acessórios,Bola com picos,Fita para a cabeça,Anel,Almofada de olhos,Tapetes"
  };

  return (defaultCategories[languageCode] || defaultCategories.en).split(',').map(category => category.trim());
}

function resetAndInitialize(searchWrapper, typingText) {
  const activeLanguageCode = getActiveLanguage();
  const categories = getCategoriesByLanguage(activeLanguageCode);

  typingText.textContent = "";
  
  setTimeout(() => {
    typeEffect(typingText, categories);
  }, 100);
}

waitForElement(".header__secondary-nav .header__icon-list", (iconList) => {
  const searchWrapper = document.createElement("div");
  searchWrapper.classList.add("pf-search-bar-wrapper");

  const inputWrapper = document.createElement("div");
  inputWrapper.classList.add("pf-search-input-wrapper");

  const typingInput = document.createElement("input");
  typingInput.classList.add("pf-search-typing-input");
  typingInput.type = "text";

  const typingText = document.createElement("span");
  typingText.classList.add("pf-search-typing-texts");
  typingText.setAttribute("data-wg-notranslate", "");
  typingText.textContent = "";

  const searchIconSVG = document.createElement("div");
  searchIconSVG.classList.add("pf-search-icon");
  searchIconSVG.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.71989 8.64739C6.83153 9.30183 5.72868 9.59643 4.63231 9.47217C3.53593 9.34791 2.527 8.81397 1.80763 7.97731C1.08826 7.14065 0.7116 6.06308 0.753098 4.96046C0.794596 3.85785 1.25119 2.81163 2.03141 2.03141C2.81163 1.25119 3.85785 0.794596 4.96046 0.753098C6.06308 0.7116 7.14065 1.08826 7.97731 1.80763C8.81397 2.527 9.34791 3.53593 9.47217 4.63231C9.59643 5.72868 9.30183 6.83152 8.64739 7.71989L11.058 10.1296C11.1225 10.1897 11.1742 10.2622 11.2101 10.3427C11.2459 10.4232 11.2652 10.5101 11.2668 10.5982C11.2683 10.6863 11.2521 10.7738 11.2191 10.8555C11.1861 10.9373 11.137 11.0115 11.0747 11.0738C11.0124 11.1361 10.9381 11.1852 10.8564 11.2182C10.7747 11.2513 10.6872 11.2675 10.5991 11.2659C10.5109 11.2644 10.424 11.2451 10.3435 11.2092C10.263 11.1733 10.1906 11.1216 10.1305 11.0571L7.71989 8.64739ZM8.18801 5.12464C8.18801 5.93686 7.86536 6.71582 7.29103 7.29015C6.7167 7.86448 5.93774 8.18714 5.12551 8.18714C4.31329 8.18714 3.53433 7.86448 2.96 7.29015C2.38567 6.71582 2.06301 5.93686 2.06301 5.12464C2.06301 4.31241 2.38567 3.53345 2.96 2.95912C3.53433 2.38479 4.31329 2.06214 5.12551 2.06214C5.93774 2.06214 6.7167 2.38479 7.29103 2.95912C7.86536 3.53345 8.18801 4.31241 8.18801 5.12464Z" fill="black"/>
    </svg>
  `;

  inputWrapper.appendChild(typingInput);
  inputWrapper.appendChild(typingText);
  searchWrapper.appendChild(inputWrapper);
  searchWrapper.appendChild(searchIconSVG);

  function adjustSearchWrapperPlacement() {
    const headerWrapper = document.querySelector(".header__wrapper");
    if (!headerWrapper) return;

    if (window.innerWidth < 900) {
      if (searchWrapper.parentNode === iconList) {
        iconList.removeChild(searchWrapper);
      }
      if (!headerWrapper.contains(searchWrapper)) {
        headerWrapper.appendChild(searchWrapper);
      }
    } else {
      if (searchWrapper.parentNode === headerWrapper) {
        headerWrapper.removeChild(searchWrapper);
      }
      if (!iconList.contains(searchWrapper)) {
        iconList.prepend(searchWrapper);
      }
    }
  }

  adjustSearchWrapperPlacement();
  window.addEventListener("resize", adjustSearchWrapperPlacement);


  resetAndInitialize(searchWrapper, typingText);

  const weglot = document.querySelector('#weglot-listbox');

  if (weglot) {
    weglot.addEventListener("click", (event) => {
      const li = event.target.closest(".wg-li");
      if (li) {
        event.preventDefault();
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    });
  }

  searchWrapper.addEventListener("click", (event) => {
    event.preventDefault();
    const originalSearchLink = document.querySelector(".header__secondary-nav .header__icon-list a[href='/search']");
    if (originalSearchLink) {
      originalSearchLink.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    }
  });
});

function removeSearchIconClass() {
  const searchWrapper = document.querySelector(".pf-search-bar-wrapper");

  if (searchWrapper) {
    const searchIconElement = document.querySelector(".searchIcon");

    if (searchIconElement) {
      searchIconElement.classList.remove("searchIcon");

      const cleanElement = searchIconElement.cloneNode(true);
      searchIconElement.replaceWith(cleanElement);
    }
  }
}